import { Breadcrumbs } from "../../../components/Breadcrumbs";
import Button from "../../../components/Button/Button";
import React, { useEffect, useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { ScaleLoader } from "react-spinners";
import { useUpdateMenuStatus } from "../../../network";
import classNames from "classnames";

export const MenuPageHeader = ({
    pages,
    setPages,
    isAllDisabled,
    isAddingNewMenu,
    isEditingCurrentMenu,
}) => {
    const { t } = useTranslation();
    const cn = classNames;
    const queryClient = useQueryClient();
    const { slug } = useParams();
    const { mutate: updateStatus, isLoading } = useUpdateMenuStatus(slug);

    const { data: menuInformation } =
        queryClient.getQueryData(["menu-list", slug]) || {};

    const status = menuInformation?.status;

    const categories = useMemo(
        () => ({ name: t("Menu"), path: "/chain/menu" }),
        []
    );

    const handleUpdateStatus = () => {
        updateStatus({
            slug,
            body: { status: status !== "archived" ? "archived" : "active" },
        });
    };

    useEffect(() => {
        if (!slug) {
            setPages(() => [
                { ...categories },
                {
                    name: t("Create New Menu"),
                    path: "/chain/menu/create",
                },
            ]);
        } else if (slug && menuInformation) {
            setPages(() => [
                { ...categories },
                {
                    name: menuInformation.name,
                    path: `/chain/menu/${menuInformation.id}/edit`,
                },
            ]);
        }
    }, []);

    return (
        <div className="col-span-6 flex flex-col lg:flex-row items-start justify-between lg:items-center mb-3">
            <Breadcrumbs pages={pages} />

            <div className="flex items-center gap-2">
                {menuInformation && (
                    <Button
                        type="button"
                        color="bg-danger"
                        className={cn("h-9", {
                            ["bg-purple-500 focus:border-purple-600 text-sm text-white shadow-sm hover:bg-purple-600"]:
                                status === "archived",
                        })}
                        isUpperCase={false}
                        disabled={isLoading}
                        isLoading={isLoading}
                        onClick={handleUpdateStatus}
                    >
                        {(status === "active" || status === "inactive") &&
                            t("Archive")}
                        {status === "archived" && t("Activate")}
                    </Button>
                )}
                {status !== "archived" && (
                    <>
                        <Button
                            type="link"
                            to="/chain/menu"
                            color="bg-gray-300"
                            className="h-9"
                            isUpperCase={false}
                            disabled={isAllDisabled}
                        >
                            {t("Cancel")}{" "}
                        </Button>
                        <Button
                            type="submit"
                            isUpperCase={false}
                            className="h-9"
                            disabled={isAllDisabled}
                            isLoading={isAddingNewMenu || isEditingCurrentMenu}
                        >
                            {t("Save")}{" "}
                        </Button>
                    </>
                )}
            </div>
        </div>
    );
};
